import React, { useState, useEffect } from "react";
import Spinner from "../common/Spinner";
// import { useNavigate } from "react-router-dom";
import { createBreadOrder } from "../../helpers/breads";
import styles from './Bread.module.css';
// import { Bread } from "../../models/BreadOrder.ts";
import Modal from "../common/Modal";
import BreadOrder from "./BreadOrder";
import CustomerPicker from '../customers/CustomerPicker';
import { logBeginOrder, logSubmitOrder, logOrderSuccess, logOrderError, OrderTypes } from '../../services/analytics.service';

export default function BreadForm() {
    const [loading, setLoading] = useState(false);

    const [date, setDate] = useState('');
    const [time, setTime] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [breads, setBreads] = useState([{ bread: '', quantity: '' }]);
    const [comments, setComments] = useState('');
    const [cashier, setCashier] = useState('');

    // Customer state
    const [customerId, setCustomerId] = useState(null);

    const [dateValid, setDateValid] = useState(true);
    const [timeValid, setTimeValid] = useState(true);
    const [firstNameValid, setFirstNameValid] = useState(true);
    const [lastNameValid, setLastNameValid] = useState(true);
    const [phoneNumberValid, setPhoneNumberValid] = useState(true);
    const [breadsValid, setBreadsValid] = useState(true);
    const [cashierValid, setCashierValid] = useState(true);

    const [submittedOrder, setSubmittedOrder] = useState(null);

    useEffect(() => {
        logBeginOrder(OrderTypes.BREAD);
    }, []);

    function handleCustomerChange({ firstName: fn, lastName: ln, phoneNumber: pn, customerId: cid }) {
        setFirstName(fn);
        setLastName(ln);
        setPhoneNumber(pn);
        setCustomerId(cid);
        if (fn) setFirstNameValid(true);
        if (ln) setLastNameValid(true);
        if (pn) setPhoneNumberValid(true);
    }

    function validate() {
        if (date === '') setDateValid(false);
        if (time === '') setTimeValid(false);
        if (firstName === '') setFirstNameValid(false);
        if (lastName === '') setLastNameValid(false);
        if (phoneNumber === '' || !phoneNumberValid) setPhoneNumberValid(false);
        let breadsValid = true;
        breads.forEach((item) => {
            if (!item.bread || !item.quantity) {
                breadsValid = false;
            }
        });
        setBreadsValid(breadsValid);
        if (!breadsValid) {
            alert("Te falto rellenar un espacio en los panes");
            return false;
        }
        if (date === '' || time === '' || firstName === '' || lastName === '' || phoneNumber === '' || !phoneNumberValid || !breadsValid || cashier === '') {
            alert("Te falto rellenar un espacio o el número de teléfono no es válido");
            return false;
        }

        return true;
    }

    async function onFormSubmit(e) {
        e.preventDefault();
        if (!validate()) return;
        setLoading(true);

        logSubmitOrder(OrderTypes.BREAD, {
            hasCustomer: Boolean(customerId),
            hasPrepayment: false
        });

        const breadObject = {
            date,
            time,
            firstName,
            lastName,
            phoneNumber,
            bread: breads,
            comments,
            cashier,
            customerId: customerId || null
        };

        try {
            const breadOrder = await createBreadOrder(breadObject);
            logOrderSuccess(OrderTypes.BREAD, breadOrder.id);
            setSubmittedOrder(breadOrder);
            resetForm();
        } catch (error) {
            logOrderError(OrderTypes.BREAD, 'submission_failed');
            console.error('Error sending order:', error);
            alert("Su orden NO fue enviada\n" + error.message);
        } finally {
            setLoading(false);
        }
    }

    function handleBreadChange(index, field, value) {
        const newBreads = [...breads];
        newBreads[index][field] = value;
        setBreads(newBreads);
    }

    function addBread() {
        setBreads([...breads, { bread: '', quantity: '' }]);
    }

    function removeBread(index) {
        const newBreads = breads.filter((_, i) => i !== index);
        setBreads(newBreads);
    }

    function closeModal() {
        setSubmittedOrder(null);
    }

    function resetForm() {
        setDate('');
        setTime('');
        setFirstName('');
        setLastName('');
        setPhoneNumber('');
        setBreads([{ bread: '', quantity: '' }]);
        setComments('');
        setCashier('');
        setCustomerId(null);
    }   

    return (
        <div className="basicContainer">
            <div className="form breadForm">
                <h1 className="formTitle">Pan</h1>
                <div>
                    <form onSubmit={onFormSubmit}>
                        {/* Pickup Section */}
                        <div className={styles['bread-form-section']}>
                            <h3 className={styles['bread-form-section-title']}>Fecha y Hora</h3>
                            <div className={styles['bread-form-row']}>
                                <div className="formEntry">
                                    <label htmlFor="date" className="form-label">Fecha</label>
                                    <input type="date"
                                           className={`${dateValid ? 'validInputField' : 'invalidInputField'}`}
                                           id="date"
                                           value={date}
                                           name="date"
                                           min={new Date().toISOString().split('T')[0]}
                                           onChange={(e) => {
                                               setDate(e.target.value);
                                               setDateValid(true);
                                           }}
                                    />
                                </div>

                                <div className="formEntry">
                                    <label htmlFor="time" className="form-label">Hora</label>
                                    <select className={`${timeValid ? 'validInputField' : 'invalidInputField'}`}
                                            name="time"
                                            onChange={(e) => {
                                                setTime(e.target.value);
                                                setTimeValid(true);
                                            }}
                                            value={time}>
                                        <option value="">...</option>
                                        <option value="11am">11am</option>
                                        <option value="12pm">12pm</option>
                                        <option value="1pm">1pm</option>
                                        <option value="2pm">2pm</option>
                                        <option value="3pm">3pm</option>
                                        <option value="4pm">4pm</option>
                                        <option value="5pm">5pm</option>
                                        <option value="6pm">6pm</option>
                                        <option value="7pm">7pm</option>
                                        <option value="8pm">8pm</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        {/* Customer Fields */}
                        <CustomerPicker
                            value={{ firstName, lastName, phoneNumber, customerId }}
                            onChange={handleCustomerChange}
                            validation={{ firstNameValid, lastNameValid, phoneNumberValid }}
                        />

                        {/* Bread Items Section */}
                        <div className={styles['bread-form-section']}>
                            <h3 className={styles['bread-form-section-title']}>Panes</h3>
                            <div className={styles['bread-items-container']}>
                                {breads.map((item, index) => (
                                    <div key={index} className={styles['bread-item-row']}>
                                        <input
                                            type="number"
                                            className={`${styles['bread-item-quantity']} ${breadsValid ? 'validInputField' : 'invalidInputField'}`}
                                            id={`quantity-${index}`}
                                            value={item.quantity}
                                            name={`quantity-${index}`}
                                            placeholder="Qty"
                                            min="1"
                                            onChange={(e) => handleBreadChange(index, 'quantity', e.target.value)}
                                        />
                                        <input
                                            type="text"
                                            className={`${styles['bread-item-type']} ${breadsValid ? 'validInputField' : 'invalidInputField'}`}
                                            id={`bread-${index}`}
                                            value={item.bread}
                                            name={`bread-${index}`}
                                            placeholder="Tipo de pan"
                                            onChange={(e) => handleBreadChange(index, 'bread', e.target.value)}
                                        />
                                        <button
                                            type="button"
                                            className={styles['bread-remove-btn']}
                                            onClick={() => removeBread(index)}
                                            title="Eliminar"
                                        >
                                            &times;
                                        </button>
                                    </div>
                                ))}
                                <button type="button" className={styles['bread-add-btn']} onClick={addBread}>
                                    + Agregar Pan
                                </button>
                            </div>
                        </div>

                        {/* Notes Section */}
                        <div className={styles['bread-form-section']}>
                            <h3 className={styles['bread-form-section-title']}>Notas</h3>
                            <div className={styles['bread-notes-row']}>
                                <div className="formEntry">
                                    <label htmlFor="comments" className="form-label">Comentarios</label>
                                    <textarea id="comments" name="comments" value={comments} onChange={(e) => setComments(e.target.value)}></textarea>
                                </div>

                                <div className="formEntry">
                                    <label htmlFor="cashier" className="form-label">Cajero</label>
                                    <input type="text" className={`${cashierValid ? 'validInputField' : 'invalidInputField'}`} id="cashier"
                                           value={cashier}
                                           name="cashier"
                                           onChange={(e) => {
                                               setCashier(e.target.value);
                                               setCashierValid(true);
                                           }}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Submit Section */}
                        <div className={styles['bread-submit-section']}>
                            {loading ? (
                                <Spinner />
                            ) : (
                                <button
                                    type="submit"
                                    className={styles['bread-submit-btn']}
                                    disabled={!phoneNumberValid || phoneNumber === ''}
                                >
                                    Enviar
                                </button>
                            )}
                        </div>
                    </form>
                </div>
            </div>
            {submittedOrder && (
                <Modal onClose={closeModal}>
                    <BreadOrder bread={submittedOrder} />
                </Modal>
            )}
        </div>
    );
}

